"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FPE_FIELD_KEY_PATTERN () {
        return FPE_FIELD_KEY_PATTERN;
    },
    get FPE_FORM_VERSION_MAX_LENGTH () {
        return FPE_FORM_VERSION_MAX_LENGTH;
    },
    get FPE_FORM_VERSION_PATTERN () {
        return FPE_FORM_VERSION_PATTERN;
    },
    get FPE_REQUIRED_VITAL_KEYS () {
        return FPE_REQUIRED_VITAL_KEYS;
    },
    get FPE_SECTION_KEY_PATTERN () {
        return FPE_SECTION_KEY_PATTERN;
    },
    get FPE_TEXT_MAX_LENGTH_DEFAULT () {
        return FPE_TEXT_MAX_LENGTH_DEFAULT;
    },
    get isCustomFpeFieldKind () {
        return isCustomFpeFieldKind;
    },
    get isFpeFieldVisible () {
        return isFpeFieldVisible;
    },
    get missingFpeVitals () {
        return missingFpeVitals;
    },
    get validateFpeFormDescriptor () {
        return validateFpeFormDescriptor;
    }
});
const _vitals = require("../encounters/vitals");
const FPE_SECTION_KEY_PATTERN = /^[a-z]+\.[a-z][a-zA-Z0-9]*$/;
const FPE_FIELD_KEY_PATTERN = /^[a-z][a-zA-Z0-9]*$/;
const FPE_FORM_VERSION_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*-v[0-9]+$/;
const FPE_FORM_VERSION_MAX_LENGTH = 64;
const FPE_TEXT_MAX_LENGTH_DEFAULT = 2000;
const FPE_REQUIRED_VITAL_KEYS = [
    'bp',
    ...Object.keys(_vitals.VITALS_RANGES)
];
const OPTION_KINDS = [
    'select',
    'multiselect'
];
const TEXT_KINDS = [
    'text',
    'textarea'
];
const BOOLEAN_KINDS = [
    'yesno',
    'checkbox'
];
const ANSWER_KINDS = [
    ...TEXT_KINDS,
    'number',
    'date',
    ...OPTION_KINDS,
    ...BOOLEAN_KINDS
];
const CUSTOM_KIND_PATTERN = /^custom:[a-z][a-zA-Z0-9]*$/;
const isCustomFpeFieldKind = (kind)=>kind.startsWith('custom:');
const checkField = (field, fieldsByKey, where)=>{
    const problems = [];
    const at = `${where} field ${field.key}`;
    if (!FPE_FIELD_KEY_PATTERN.test(field.key)) {
        problems.push(`${at}: key must be camelCase`);
    }
    const isCustom = isCustomFpeFieldKind(field.kind);
    if (isCustom && !CUSTOM_KIND_PATTERN.test(field.kind)) {
        problems.push(`${at}: custom kind must be custom:<camelCaseName>`);
    }
    if (!isCustom && !ANSWER_KINDS.includes(field.kind)) {
        problems.push(`${at}: unknown kind`);
    }
    const takesOptions = OPTION_KINDS.includes(field.kind);
    if (takesOptions) {
        const values = (field.options ?? []).map((option)=>option.value);
        if (values.length === 0) {
            problems.push(`${at}: needs options`);
        }
        if (new Set(values).size !== values.length) {
            problems.push(`${at}: option values must be unique`);
        }
    } else if (field.options !== undefined) {
        problems.push(`${at}: options are only for select and multiselect`);
    }
    if (field.kind !== 'number' && (field.min !== undefined || field.max !== undefined)) {
        problems.push(`${at}: min and max are only for number`);
    }
    if (field.min !== undefined && field.max !== undefined && field.min > field.max) {
        problems.push(`${at}: min is greater than max`);
    }
    if (!TEXT_KINDS.includes(field.kind) && field.maxLength !== undefined) {
        problems.push(`${at}: maxLength is only for text and textarea`);
    }
    if (field.maxLength !== undefined && (!Number.isInteger(field.maxLength) || field.maxLength < 1)) {
        problems.push(`${at}: maxLength must be a positive whole number`);
    }
    if (field.showIf !== undefined) {
        problems.push(...checkShowIf(field, fieldsByKey, at));
    }
    return problems;
};
const checkShowIf = (field, fieldsByKey, at)=>{
    const showIf = field.showIf;
    const target = fieldsByKey.get(showIf.field);
    if (target === undefined || showIf.field === field.key) {
        return [
            `${at}: showIf must name another field in the same section`
        ];
    }
    if (target.showIf !== undefined) {
        return [
            `${at}: showIf target may not have its own showIf`
        ];
    }
    if (OPTION_KINDS.includes(target.kind)) {
        const values = (target.options ?? []).map((option)=>option.value);
        if (typeof showIf.equals !== 'string' || !values.includes(showIf.equals)) {
            return [
                `${at}: showIf value must be one of the target's options`
            ];
        }
        return [];
    }
    if (BOOLEAN_KINDS.includes(target.kind)) {
        if (typeof showIf.equals !== 'boolean') {
            return [
                `${at}: showIf value must be true or false for a yes/no or checkbox target`
            ];
        }
        return [];
    }
    return [
        `${at}: showIf target must be a select, multiselect, yesno or checkbox field`
    ];
};
const validateFpeFormDescriptor = (descriptor)=>{
    const problems = [];
    if (!FPE_FORM_VERSION_PATTERN.test(descriptor.formVersion) || descriptor.formVersion.length > FPE_FORM_VERSION_MAX_LENGTH) {
        problems.push('formVersion has the wrong format');
    }
    for (const vital of descriptor.requiredVitals){
        if (!FPE_REQUIRED_VITAL_KEYS.includes(vital)) {
            problems.push(`requiredVitals has an unknown vital ${String(vital)}`);
        }
    }
    const sectionKeys = new Set();
    for (const section of descriptor.sections){
        const where = `section ${section.key}`;
        if (!FPE_SECTION_KEY_PATTERN.test(section.key)) {
            problems.push(`${where}: key must be <namespace>.<camelCaseName>`);
        }
        if (sectionKeys.has(section.key)) {
            problems.push(`${where}: duplicate section key`);
        }
        sectionKeys.add(section.key);
        const fieldsByKey = new Map();
        for (const field of section.fields){
            if (fieldsByKey.has(field.key)) {
                problems.push(`${where}: duplicate field key ${field.key}`);
            }
            fieldsByKey.set(field.key, field);
        }
        const customCount = section.fields.filter((field)=>isCustomFpeFieldKind(field.kind)).length;
        if (customCount > 0 && section.fields.length !== 1) {
            problems.push(`${where}: a custom field must be the only field in its section`);
        }
        for (const field of section.fields){
            problems.push(...checkField(field, fieldsByKey, where));
        }
    }
    return problems;
};
const isFpeFieldVisible = (field, sectionAnswers)=>{
    if (field.showIf === undefined) {
        return true;
    }
    const value = sectionAnswers?.[field.showIf.field];
    if (Array.isArray(value)) {
        return value.includes(field.showIf.equals);
    }
    return value === field.showIf.equals;
};
const isPresent = (value)=>value !== null && value !== undefined;
const missingFpeVitals = (descriptor, vitals)=>descriptor.requiredVitals.filter((vital)=>{
        if (vital === 'bp') {
            return !(isPresent(vitals?.bpSystolic) && isPresent(vitals?.bpDiastolic));
        }
        return !isPresent(vitals?.[vital]);
    });
